module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SpecialProductView.js"));
	}, "SpecialProductView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpecialProductView!./src/pages/Shop/Home/SpecialProduct/SpecialProductView.js
// module id = 926
// module chunks = 431